import ComboWizard from '../shared/combo-wizard'
import { interpretStep } from './functions'
import { SANACION_PROFUNDA_NAME, SANACION_PROFUNDA_STEPS } from './combo-config'

const SanacionProfunda = () => (
    <ComboWizard
        comboName={SANACION_PROFUNDA_NAME}
        steps={SANACION_PROFUNDA_STEPS}
        bgClass="bg-sanacion-profunda"
        interpretStep={interpretStep}
        consultaPlaceholder="Inquietud del consultante sobre sanación, heridas o patrones (opcional). Se usará en las 3 tiradas del combo."
    />
)

export default SanacionProfunda
